import request from '@/utils/request';

/**获取验证码 */
export const sendVerificationCode= (phone:string)=>{
    let param = {
        'phone':phone
    }
    return request.post(
      '/api/System/SendVerificationCodeUseChangePhone',
      param);
  };


  /**获取资金账户列表 */
export const systemeAccount = function () {
    let url = "/api/System/Account";
    return request
        .get(url, {
        })
}